import React from "react";
import { motion } from "framer-motion";

const CARDS = [
    {
        title: "2D",
        video: "/services/2d.mp4",
        delay: 0.1,
        description: "Bold, playful motion that makes flat graphics bounce off the screen",
        gradient: "linear-gradient(135deg, #D8FF3D 0%, #7BE04A 50%, #2E5A1C 100%)",
    },
    {
        title: "3D",
        video: "/services/3d.mp4",
        delay: 0.2,
        description: "Shiny, textural, slick and tactile worlds built to pull you in",
        gradient: "linear-gradient(135deg, #FFC53D 0%, #D8FF3D 55%, #6B7A1E 100%)",
    },
    {
        title: "Illustration",
        video: "/services/illustration.mp4",
        delay: 0.3,
        description: "Characterful illustrations that blend in with your brand and stand out in the world",
        gradient: "linear-gradient(135deg, #EFFFB0 0%, #A8E63D 50%, #3D6B2E 100%)",
    },
];

export function FeatureCardsSection() {
    return (
        <section
            data-testid="feature-cards-section"
            className="w-full flex flex-col items-center justify-center p-6 md:p-12 py-20 md:py-28"
            style={{ background: "var(--bg)" }}
        >
            <div className="w-full max-w-[936px] mb-12 md:mb-16">
                <div className="text-base uppercase tracking-[0.3em]" style={{ color: "var(--accent)" }}>
                    WHAT WE MAKE
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-3 lg:gap-3 w-full max-w-[936px]">
                {CARDS.map((c, i) => (
                    <FeatureCard key={c.title} index={i} {...c} />
                ))}
            </div>
        </section>
    );
}

function FeatureCard({ title, description, video, gradient, delay, index }) {
    return (
        <motion.div
            data-testid={`feature-card-${index}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: "easeOut", delay }}
            className="relative flex flex-col justify-start items-start w-full max-w-[260px] md:max-w-[300px] group mx-auto"
        >
            {/* Glow background */}
            <div
                className="absolute inset-0 w-full h-[260px] md:h-[300px] opacity-60 rounded-[40px] pointer-events-none"
                style={{ background: gradient, filter: "blur(45px)" }}
            />
            {/* Foreground card with gradient border */}
            <div
                className="relative self-stretch h-[260px] md:h-[300px] rounded-[40px] z-10 overflow-hidden"
                style={{
                    border: "8px solid transparent",
                    background: `linear-gradient(#1A1A1C, #1A1A1C) padding-box, ${gradient} border-box`,
                }}
            >
                <div className="w-full h-full p-7 flex flex-col justify-between">
                    <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-black">
                        <video
                            src={video}
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="auto"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div>
                        <h3
                            className="text-white font-medium text-xl mb-3 tracking-tight"
                            style={{ fontFamily: "'Glacial Indifference', sans-serif" }}
                        >
                            {title}
                        </h3>
                        <p className="text-gray-400 text-base leading-[1.6] font-normal selection:bg-white/20">
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}
